import { observable } from '@legendapp/state';

import { VerticalBreakpoints } from '../../hooks/use-vertical-breakpoint';

import { DeviceOrientation, DeviceType, deviceSettingStore } from './device-setting-store';
import { fullscreenStore } from './fullscreen-store';

interface SliderStore {
	isDoubleSliderVisible: boolean;
}

export const sliderStore = observable<SliderStore>({
	isDoubleSliderVisible: () => {
		const { isMobileDevice, deviceType, deviceOrientation, screenHeight } = deviceSettingStore.get();
		const isLandscapeOrientation = deviceOrientation === DeviceOrientation.Landscape;
		const isIpad = deviceType === DeviceType.iPad;
		const isFullscreenMode = fullscreenStore.isFullscreenMode.get();
		const smallMobileHeightCondition = screenHeight < VerticalBreakpoints.b340;

		return ((isLandscapeOrientation && smallMobileHeightCondition) || isFullscreenMode) && isMobileDevice && !isIpad;
	}
});
